import { appAssetsCdnUrl } from '~/constants/environment';
import { useConfiguration } from '~/context/common/StaticContext';
import useLogInAndSaveSearch from '~/hooks/srp/useLogInAndSaveSearch';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  position: number;
};

export default function SaveSearchTile({ position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const handleSaveSearch = useLogInAndSaveSearch();

  return (
    <ConditionalTile
      anchorProps={{
        id: 'SaveSearchTile',
        'data-analytics-id': 'Conditional Tile',
        'data-analytics-attributes': JSON.stringify({
          action: 'clicked',
          tile: 'Save Search Tile',
          position
        }),
        onClick: handleSaveSearch
      }}
      ctaCopy={shouldUseTitleCasing ? 'Save This Search' : 'Save this search'}
      description="Matching vehicles straight to your inbox. Over 1,000 vehicles added daily!"
      imageProps={{
        src: `${appAssetsCdnUrl}/images/heliosConditionalTiles/savesearch-illustration.png`,
        alt: 'Save Search'
      }}
      position={position}
      tileName="SaveSearchTile"
      title="Save your search"
    />
  );
}
